<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <h5>VOLUME REALISASI VS RKAP</h5>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <el-form  class="mt-2 demo-dynamic" label-position="top" label-width="100px" :inline="true">
                
                    <el-form-item label="">
                        <el-select v-model="year" filterable placeholder="Select Year" size="medium" style="max-width: 100px;">
                            <el-option v-for="item3 in options.years" :key="item3.value" :label="item3.name" :value="item3.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                
                    <el-form-item label="">
                        <el-select v-model="month" filterable placeholder="Select Month" size="medium" style="max-width: 120px;">
                            <el-option v-for="item3 in options.months" :key="item3.value" :label="item3.name" :value="item3.value">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="">
                        <el-radio-group v-model="showperiodtype" size="medium" class="ms-0">
                            <el-radio-button label="current">CURRENT</el-radio-button>
                            <el-radio-button label="ytd">YTD</el-radio-button>
                            <el-radio-button label="year">RKAP {{ year }}</el-radio-button>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item>
                        <el-radio-group v-model="salesarea" size="medium">
                            <el-radio label="" border>All SA</el-radio>
                            <el-radio label="1" border>SA 1</el-radio>
                            <el-radio label="2" border>SA 2</el-radio>
                            <el-radio label="3" border>SA 3</el-radio>
                            <el-radio label="4" border>SA 4</el-radio>
                            <el-radio label="5" border>SA 5</el-radio>
                        </el-radio-group>
                    </el-form-item>
                
                    <el-form-item v-if="false">
                        <el-button size="medium" :loading="loading.table" @click="applyFilter">Konsol</el-button>
                    </el-form-item>
                    
                </el-form>
            </div>
        </div>

        <div class="row">
            <div class="col-md-4 mb-4">
                <el-card shadow="hover">
                    <div slot="header" class="px-1">
                        <h6 class="text-center m-0">PROPORSI KINERJA</h6>
                    </div>
                
                    <PieChart class="mt-0" :data="this.chartproporsikinerjadata" :url="''" style="width:100%;" :showlegend="true"/>
                    <Loader v-if="loading.chart" />
                </el-card>
            </div>  
            <div class="col-md-8 mb-4">
                <el-card shadow="hover">
                    <div slot="header" class="px-1">
                        <h6 class="text-center m-0">JUMLAH UNIT</h6>
                    </div>
                    <BarChart :data="barchartsmartstylishexperiencedata" :width="500" :height="450" />
                    <Loader v-if="loading.chart" />
                </el-card>
            </div>  
        </div>

        <div class="row">
            <div class="col-md-12 mb-4">
                <el-card shadow="hover">
                    <div slot="header" class="px-1">
                        <div class="text-center m-0">
                            <span style="font-weight: 600;">REALISASI VS RKAP {{ titlecategory }}</span>
                          
                            <el-radio-group v-model="showperiodtype" size="mini" class="ms-3">
                                <el-radio-button label="current">CURRENT</el-radio-button>
                                <el-radio-button label="ytd">YTD</el-radio-button>
                                <el-radio-button label="year">RKAP {{ year }}</el-radio-button>
                            </el-radio-group>
                 
                            <el-radio-group v-model="rkapcategory" size="mini" class="ms-4" v-if="false">
                                <el-radio-button label="ytd">RKAP YTD</el-radio-button>
                                <el-radio-button label="rkap">RKAP {{ year }}</el-radio-button>
                            </el-radio-group>

                            <el-button type="success" class="ms-4" size="mini" @click="exportToExcel">Export to Excel</el-button>
                        </div> 
                    </div>
                    <div>
                        <div class="table-pl-lapmen-container">
                            <table class="table-pl-lapmen">
                                <thead class="top-header-1">
                                    <tr>
                                        <th style="width:40px;">No</th>
                                        <th>Unit</th>
                                        <th>RKAP {{ titlecategory }}</th>
                                        <th>Realisasi</th>
                                        <th>Realisasi VS RKAP</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item,idx) in reportdata?.data?.achievement_detail?.data" :key="item">
                                        <td class="text-center">{{ ++idx }}</td>
                                        <td>{{ item.UnitName }}</td>
                                        <td class="text-right">{{ formatNum(item.Target) }}</td>
                                        <td class="text-right">{{ formatNum(item.Realisasi) }}</td>
                                        <td>
                                            <div class="bar-container">
                                                <div class="bar bar-1" :style="{ width: parseFloat(item.ProgressPercentage) >= 100 + '%' ? 100 : parseInt(item.ProgressPercentage) + '%' }" :title="formatNum(item.Realisasi)">{{ formatNum(item.ProgressPercentage) }}%</div>
                                                <div class="bar bar-2" :style="{ width: parseFloat(item.ProgressPercentage) < 100 ? (100-parseFloat(item.ProgressPercentage)) + '%' : '0%' }" :title="formatNum(item.Target)">{{ displayProgress(item.ProgressPercentage) }}</div>
                                            </div>
                                        </td>
                                        <td class="text-center"><el-tag :type="parseFloat(item.Realisasi) >= parseFloat(item.Target) ? 'success' : 'danger'" effect="dark" size="small">{{ item.Status }}</el-tag></td>
                                    </tr>
                                    <tr v-if="(reportdata?.data?.achievement_detail?.data?.length ?? 0) <=0">
                                        <td class="text-center" colspan="6">
                                            <i>Tidak ada data</i>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </el-card>
                <Loader v-if="loading.table" />
            </div>
        </div>

        <div class="row">
            <div class="col-md-6 mb-4">
                <el-card shadow="hover">
					<div slot="header">
						<h5 class="text-center m-0 px-2">TOP 5 REALISASI {{ titlecategory }}</h5>
					</div>
					<div class="list-item-container px-2">
						<table class="table-outstanding-status-by-area" style="width: 100%;" cellpadding="2">
							<thead>
								<tr class="">
									<td class="py-2 text-muted">#</td>
									<td class="text-muted"><em>Cost Center</em></td>
									<td class="text text-muted"><em>Unit Name</em></td>
									<td class="text-center text-muted"><em>Realisasi</em></td>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, index) in reportdata?.data?.top_realisasi" :key="item.CostCenter">
									<td class="py-2">{{ ++index }}</td>
									<td>{{ item.CostCenter }}</td>
									<td class="text-left">{{ (item.UnitName) }}</td>
									<td class="text-right font-weight-bold">{{ formatNum(item.Realisasi, 0) }}</td>
								</tr>
							</tbody>
						</table>
					</div>
					<Loader v-if="loading.table" />
				</el-card>
            </div>

            <div class="col-md-6 mb-4">
                <el-card shadow="hover">
					<div slot="header">
						<h5 class="text-center m-0 px-2">BOTTOM 5 REALISASI {{ titlecategory }}</h5>
					</div>
					<div class="list-item-container px-2">
						<table class="table-outstanding-status-by-area" style="width: 100%;" cellpadding="2">
							<thead>
								<tr class="">
									<td class="py-2 text-muted">#</td>
									<td class="text-muted"><em>Cost Center</em></td>
									<td class="text text-muted"><em>Unit Name</em></td>
									<td class="text-center text-muted"><em>Realisasi</em></td>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item, index) in reportdata?.data?.bottom_realisasi" :key="item.CostCenter">
									<td class="py-2">{{ ++index }}</td>
									<td>{{ item.CostCenter }}</td>
									<td class="text-left">{{ (item.UnitName) }}</td>
									<td class="text-right font-weight-bold">{{ formatNum(item.Realisasi, 0) }}</td>
								</tr>
							</tbody>
						</table>
					</div>
					<Loader v-if="loading.table" />
				</el-card>
            </div>
        </div>
        
    </div>
</template>


<script>
import KinerjaKeuangan from '@/components/page/KinerjaKeuangan.js'
import Finance from '@/components/page/Finance.js'
import ReportResultTable from '@/views/pages/ReportResultTable3.vue'
import { Rainbow, FuelColor, AppColors, Config, Penanggalan, AxiosWithJar } from '@/utility.js'
//import PieChart from '@/components/chart/Pie.js'
import PieChart from '@/components/chart/Doughnut.js'
import LineChart from '@/components/chart/LineChart.js'
import BarChart from '@/components/chart/BarChart.js'
import Loader from '@/components/loader/Loader2.vue'


export default
{
	extends: KinerjaKeuangan,
	components: { 
        PieChart,
        BarChart,
		//ReportResultTable,
        Loader,
	},

	data(){
		return {
            chartproporsikinerjadata:[],
            barchartsmartstylishexperiencedata:[],

            showperiodtype: 'ytd',

            stacked: false,
            loading: {
				table: false,
                tableDetail: false,
				chart: false,
				isSuccess: false,
                isSuccessDetail: false,
			},
            reportdata: [],
            urlRequestParams: '',
            unitId: '',
            station: {
                list: [],
            },

            titlecategory: 'YTD (' + Penanggalan().tahun +')',
            rkapcategory: 'ytd',

            month: (Penanggalan().bulan > 1 ? Penanggalan().bulan-1 : Penanggalan().bulan),
            year: ""+Penanggalan().tahun,

            salesarea: '',
			//month: '', //Penanggalan().bulan,
            //year: Penanggalan().tahun,

            options: {
                salesarea: [
                    { Value:'1', Name:'1' },
                    { Value:'2', Name:'2' },
                    { Value:'3', Name:'3' },
                    { Value:'4', Name:'4' },
                    { Value:'5', Name:'5' },
                ],
                group:[
					{ value: 'monthly', name: 'MONTHLY' },
					{ value: 'ytd', name: 'YTD' },
				],
                months:[
                    //{value:'', name: 'All/Ytd'},
                    {value:1, name: 'Januari'},
                    {value:2, name: 'Februari'},
                    {value:3, name: 'Maret'},
                    {value:4, name: 'April'},
                    {value:5, name: 'Mei'},
                    {value:6, name: 'Juni'},
                    {value:7, name: 'Juli'},
                    {value:8, name: 'Agustus'},
                    {value:9, name: 'September'},
                    {value:10, name: 'Oktober'},
                    {value:11, name: 'November'},
                    {value:12, name: 'Desember'},
                ],
                years:[
                    {value:'2021', name: '2021'},
                    {value:'2022', name: '2022'},
                    {value:'2023', name: '2023'},
                    {value:'2024', name: '2024'},
                    {value:'2025', name: '2025'},
                ],
            },

            group : 'monthly',

		}
	},
	watch:
	{
		rkapcategory() { 
            //unused, use showperiodtype
            if(this.rkapcategory == 'ytd') {
                this.titlecategory = 'YTD';
            } else {
                this.titlecategory = this.year;
            }

            this.setTitle();
            this.getData();
        },
		month() { 
            this.setTitle();
            this.getData() 
        },
		year() { 
            this.setTitle();
            this.getData() 
        },
		salesarea() { 
            this.setTitle();
            this.getData();
        },
		showperiodtype() { 
            this.setTitle();
            this.getData() 
        },
	}, 
    mounted()
    {
        this.$emit('childrenRoute');
        this.setTitle();
        this.getData() ;
    },
    beforeDestroy() {
        
    },
    methods:{
        async getData() {
			this.urlRequestParams = Config().apiURL
			this.urlRequestParams+='/v1/plunit/achievement?'

			this.urlRequestParams+='&month='+this.month
            this.urlRequestParams+='&year='+this.year
            this.urlRequestParams+='&area='+this.salesarea
            this.urlRequestParams+='&showperiodtype='+this.showperiodtype
            this.urlRequestParams+='&rkapcategory='+this.rkapcategory

			this.loading.chart = true;
			this.loading.table = true;
			this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					this.reportdata = response.data;
                    //this.filteredDataAll = response.data.data
					this.loading.isSuccess = true;

                    this.setPiecharthData();
                    this.setBarchartSmartStylishExperience();

				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
                    this.loading.chart = false;
					this.loading.table = false;
				})
        },

        setPiecharthData() {
			let item = this.reportdata.data.proporsi_kinerja; //CashPosition;
			//console.log('item pieChartData:' + JSON.stringify(item))
            var warna = []

            let value = [];
            let idx = 0;
            for (var row in item) {
                //add color
                warna[item[row].Label] = AppColors[idx]; //AppColors[idx];//'#FFB22E'

                //add value
                let main = {
                    transtype: item[row].Label, 
                    amount: item[row].Value,
                };

                value.push(main);
                idx++;
            }

            this.chartproporsikinerjadata = this.processPieChart(value, "amount", "transtype", 1, 2, warna); 
        },

        setBarchartSmartStylishExperience() {
            //console.log('this.maindata: ' + JSON.stringify(this.maindata))
            let label = 'Legend'
            let value = 'Value'
            let legend = 'Label'
            this.barchartsmartstylishexperiencedata = this.processBarChart(this.reportdata.data.smart_stylish_experience, label, '', value, false, legend, "", 1, 2, AppColors, false, false, false, this.stacked);
        },

        calculatePercentage(realisasi, target) {
            const total = parseInt(realisasi) + parseInt(target);
            return (parseInt(realisasi) / total) * 100;
        },

        generateRandomNumber() {
            let min = 500;
            let max = 10000;
            var randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
            return randomNumber;
        },

        setTitle() {
            if(this.showperiodtype == 'ytd') {
                this.titlecategory = 'YTD (' + this.options.months[this.month-1].name.toUpperCase() + ' ' + this.year +')';
            } else if (this.showperiodtype == 'year') {
                this.titlecategory = this.year;
            } else if (this.showperiodtype == 'current') {
                this.titlecategory = ' CURRENT (' + this.options.months[this.month-1].name.toUpperCase() + ' ' + this.year +')';
            }
        },

        displayProgress(progress) {
            const progressValue = parseFloat(progress);
            return progressValue < 100 ? this.formatNum(100 - progressValue) + '%' : '';
        },

        applyFilter() {
            this.loadData()
        },

        exportToExcel() {
            //console.log('export to excel');
            let data = this.reportdata?.data?.achievement_detail?.data;

            // Convert JSON data to an HTML table
            const tableHTML = this.convertJSONToTable(data);

            // Create a Blob object with the table HTML content
            const blob = new Blob([tableHTML], {
                type: "application/vnd.ms-excel",
            });

            // Create a download link
            const link = document.createElement("a");
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", "Volume Realisasi VS RKAP " + this.titlecategory + ".xls");

            // Append the link to the body and trigger the download
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },

        convertJSONToTable(jsonData) {
            let table = "<table border='1'>";

            // Create table headers
            const headers = Object.keys(jsonData[0]);
            table += "<tr>";
            headers.forEach((header) => {
                table += `<th>${header}</th>`;
            });
            table += "</tr>";

            // Create table rows
            jsonData.forEach((row) => {
                table += "<tr>";
                Object.values(row).forEach((cell) => {
                if (this.isNumberString(cell)) {
                    // Make sure Excel treats it as a number with decimal places
                    //table += `<td style="mso-number-format:'0.00000000';">${cell.replace(".", ",")}</td>`;
                    table += `<td>${cell.replace(".", ",")}</td>`;
                } else {
                    table += `<td>${cell}</td>`;
                }
                });
                table += "</tr>";
            });

            table += "</table>";
            return table;
        },

        convertJSONToTablePlain(jsonData) {
            let table = "<table border='1'>";
            
            // Create table headers
            const headers = Object.keys(jsonData[0]);
            table += "<tr>";
            headers.forEach((header) => {
                table += `<th>${header}</th>`;
            });

            table += "</tr>";
            
            // Create table rows
            jsonData.forEach((row) => {
                table += "<tr>";
                Object.values(row).forEach((cell) => {
                    table += `<td>${cell}</td>`;
                });

                table += "</tr>";
            });

            table += "</table>";
            return table;
        },

        // Helper function to detect if the string is a number-like string
        isNumberString(value) {
            return !isNaN(value) && !isNaN(parseFloat(value));
        }

    },
    computed: {
        selectedMonthLabel() {
            const selectedMonth = this.options.months.find(item => item.value === this.month);
            return selectedMonth ? selectedMonth.name.toUpperCase() : '-';
        }
    },
}
</script>

<style>

.table-pl-lapmen-container {
  /*max-width: 500px; */
  width: 100%;
  margin: auto;
  margin-top: 0rem;
  overflow-x: auto;
  max-height: 450px;
}

.table-pl-lapmen {
  font-family: "Open Sans", sans-serif;
  position: relative;
  border-collapse: initial; /** collapse */
  border-spacing: 0;
  table-layout: auto;
  width: 100%;
  border: none;
  border-radius: 0.5rem;
  /*box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06); */
  white-space: nowrap;
}

.table-pl-lapmen thead th {
  background: #edf2f7;  /* $gray-200 */
  padding: 0.45rem 1.0rem;
  vertical-align: middle;
  text-align: center;
  border: 1px solid white;
}

.top-header-1 {
    position: -webkit-sticky; /* For Safari */
    position: sticky;
    top: 0;
    z-index: 2;
}

.top-header-2 {
    position: -webkit-sticky; /* For Safari */
    position: sticky;
    top: 70;
    z-index: 2;
}

.table-pl-lapmen thead th:first-child {
    z-index: 4;
}

.table-pl-lapmen th:first-child {
  border-top-left-radius: 0.5rem;
}

.table-pl-lapmen th:last-child {
  border-top-right-radius: 0.5rem;
}


.table-pl-lapmen thead tr {
  color: #2d3748; /* $gray-800 */
  font-size: 1rem;
  font-weight: 500;
  text-align: left;
}

.table-pl-lapmen tbody tr:nth-child(odd) td {
  background: #ffffff; 
}

.table-pl-lapmen tbody tr:nth-child(even) td {
  background: #FAFBFC /*#edf2f7*/; /* $gray-200 */
}

.table-pl-lapmen tbody tr:hover {
  background-color: #e2e8f0 !important; /**e2e8f0 */
}

.table-pl-lapmen tbody tr:hover td {
  background-color: #e2e8f0;
}

.table-pl-lapmen tbody td {
  color: #1a202c; /* $gray-900 */
  text-align: left;
  padding: 0.4rem 0.5rem;
  vertical-align: middle;
  font-size: 0.925rem;
  font-weight: normal;
  border:1px solid #F0F0F0;
}

.table-pl-lapmen tr:last-child td:first-child {
  border-bottom-left-radius: 0.5rem;
}

.table-pl-lapmen tr:last-child td:last-child {
  border-bottom-right-radius: 0.5rem;
}

.table-pl-lapmen tr > th:first-child,
.table-pl-lapmen tr > td:first-child {
  position: sticky;
  left: 0;
}


.bar-container {
    display: flex;
    width: 100%;
    height: 26px;
    background-color: #e0e0e0;
    border-radius: 5px;
    overflow: hidden;
}
.bar {
    height: 100%;
    text-align: center;
    line-height: 26px;
    color: white;
    font-weight: normal;
    font-size:11px;
}
.bar-1 {
    background-color: #67C23A;
    text-align: center;
}
.bar-2 {
    background-color: #909399;
    text-align: center;
}
</style>